import React, {useState} from 'react';
import {Platform, ScrollView, View} from 'react-native';
import {useNavigation} from '@react-navigation/native';

import ModalHeader from '/component/layout/ModalHeader';
import {usePopup} from '/provider/PopupProvider';
import {useTranslation} from '/provider/TranslationProvider';

import {CandidateInputFields} from '../../CandidateProfile/CandidateInputFields/CandidateInputFields';
import {
  handleBackButton,
  handleSave,
} from '../CreateCandidateProfile/CreateCandidateProfile.util';

import {styles} from './CreateCandidateProfile.style';
interface CreateCandidateProfileScreenProps {
  userId: number;
  credentialsEmail: string;
  onClose: () => void;
  popoverShow: () => void;
  saveCandidateProfile: (...args: any[]) => void;
  lastPaidRank: string;
}

export const CreateCandidateProfileScreen: React.FC<
  CreateCandidateProfileScreenProps
> = ({
  userId = 0,
  popoverShow = () => {},
  credentialsEmail = '',
  saveCandidateProfile = null,
  lastPaidRank,
}) => {
  const {tt} = useTranslation('CreateCandidateProfile');

  const [name, setName] = useState('');
  const [nameError, setNameError] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [socialLinksError, setSocialLinksError] = useState(false);
  const [socialLinks, setSocialLinks] = useState([]);
  const [fetchApi, setFetchApi] = useState(false);
  const [socialLinkText, setSocialLinkText] = useState(new Map());
  // @ts-expect-error TS(2339): Property 'hidePopup' does not exist on type 'unkno... Remove this comment to see the full error message
  const {hidePopup, showPopup} = usePopup();
  const navigation = useNavigation();

  return (
    <ModalHeader
      isProfileScreen
      onClose={() => {
        handleBackButton({
          name,
          phoneNumber,
          email,
          navigation,
          showPopup,
          hidePopup,
          lastPaidRank,
        });
      }}
      actionLabel={'Save'}
      onActionPress={
        !fetchApi
          ? () => {
              handleSave({
                userId,
                credentialsEmail,
                name,
                email,
                phoneNumber,
                setFetchApi,
                setNameError,
                setPhoneNumberError,
                setEmailError,
                setSocialLinksError,
                saveCandidateProfile,
                socialLinkText,
                navigation,
                lastPaidRank,
              });
            }
          : () => {}
      }
      closeIconName={'chevron-left'}
      title={tt('newCandidateProfile', 'New Candidate profile')}
      style={{base: styles.base}}>
      {Platform.OS === 'web' ? (
        <View style={(styles as any).webScrollContainer}>
          <View accessible={false}>
            <CandidateInputFields
              name={name}
              email={email}
              phoneNumber={phoneNumber}
              setName={setName}
              setEmail={setEmail}
              setPhoneNumber={setPhoneNumber}
              // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
              nameError={nameError}
              setNameError={setNameError}
              // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
              emailError={emailError}
              setEmailError={setEmailError}
              // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
              phoneNumberError={phoneNumberError}
              setPhoneNumberError={setPhoneNumberError}
              // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
              socialLinksError={socialLinksError}
              socialLinkText={socialLinkText}
              setSocialLinksError={setSocialLinksError}
              setSocialLinkText={setSocialLinkText}
              popoverShow={popoverShow}
              socialLinks={socialLinks}
              setSocialLinks={setSocialLinks}
            />
          </View>
        </View>
      ) : (
        <ScrollView>
          <View accessible={false}>
            <CandidateInputFields
              name={name}
              email={email}
              phoneNumber={phoneNumber}
              setName={setName}
              setEmail={setEmail}
              setPhoneNumber={setPhoneNumber}
              // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
              nameError={nameError}
              setNameError={setNameError}
              // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
              emailError={emailError}
              setEmailError={setEmailError}
              // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
              phoneNumberError={phoneNumberError}
              setPhoneNumberError={setPhoneNumberError}
              // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
              socialLinksError={socialLinksError}
              socialLinkText={socialLinkText}
              setSocialLinksError={setSocialLinksError}
              setSocialLinkText={setSocialLinkText}
              popoverShow={popoverShow}
              socialLinks={socialLinks}
              setSocialLinks={setSocialLinks}
            />
          </View>
        </ScrollView>
      )}
    </ModalHeader>
  );
};

export default CreateCandidateProfileScreen;
